module.exports = __webpack_public_path__ + "img/header-weddingRingsFrameSettings@2x.9529f10.webp";